import PasswordValidate from '@/components/password-validate/password-validate';
import { authAPI } from '@/providers/apis/auth/auth';
import { passwordValidation } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'change-password',
    components: {
        'password-validate': PasswordValidate,
    },
})

export default class ChangePassword extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    private formData: {new_password?: string, old_password?: string} = {};

    private isSubmitted: boolean = false;

    private password: string = '';

    private dismissCountDown: number = 0;

    private isUpdated: boolean = false;



    // -------------------------------------------------------------------------
    // Actions

    private onSubmit() {
        this.isSubmitted = true;
        this.dismissCountDown = 0;
        this.$validator.validate().then((valid) => {
            if (this.formData.new_password !== this.password ||
                !passwordValidation(this.formData.new_password)) {
                return;
            }
            if (valid) {
                authAPI.changePassword(this.formData).then((res) => {
                    this.isUpdated = res === 400 ? false : true;
                    this.password = '';
                    this.formData.new_password = '';
                    this.dismissCountDown = 5;
                    this.isSubmitted = false;
                });
            }
        });
    }


    // -----------------------------------------------------------------------------
    // Methods

    private inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    private updatingPw(text: any) {
        this.password = text;
    }

}
